import { Directive, Input, OnDestroy, OnInit } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { Subject, Subscription } from 'rxjs';

@Directive({ selector: '[vfsDependandFilters]', exportAs: 'vfsDependandFilters' })
export class DependandFiltersDirective implements OnInit, OnDestroy {
  @Input() dependantControls = Array<AbstractControl>();
  @Input() reloadSubject$: Subject<Array<AbstractControl>>;

  alreadySetControls: Array<AbstractControl> = [];
  subscriptions: Array<Subscription> = [];

  constructor() {}

  ngOnInit(): void {
    this.dependantControls.forEach((control: AbstractControl) => {
      this.subscriptions.push(
        control.valueChanges.subscribe((value: any) => this.onControlValueChanged(control, value))
      );
    });
  }

  private onControlValueChanged(control: AbstractControl, value: any) {
    const controlIndex: number = this.alreadySetControls.findIndex((ctrl: AbstractControl) => ctrl === control);
    if (controlIndex !== -1) {
      this.manageAlreadySetControl(controlIndex);
    } else if (value) {
      this.manageNewlySetControl(control);
    }
  }

  private manageNewlySetControl(control: AbstractControl) {
    this.alreadySetControls.push(control);

    const controlsToReload: Array<AbstractControl> = this.dependantControls
      .filter((ctrl: AbstractControl) => ctrl !== control)
      .filter((
        ctrl: AbstractControl // Not set yet only
      ) => this.alreadySetControls.every((setControl: AbstractControl) => ctrl !== setControl));

    this.reloadSubject$.next(controlsToReload);
  }

  private manageAlreadySetControl(controlIndex: number) {
    // Remove from the "set controls" list those controls which have been set after the one that just changed.
    // Also, set their values to "null".
    this.alreadySetControls
      .splice(controlIndex + 1)
      .forEach((controlToReset: AbstractControl) => controlToReset.patchValue(null, { emitEvent: false }));

    // If the new value of the control that just changed is null, remove it from the "set controls" list
    if (!this.alreadySetControls[controlIndex].value) {
      this.alreadySetControls.splice(controlIndex, 1);
    }

    // Reload the options for those controls that have no value set
    const controlsToReload: Array<AbstractControl> = this.dependantControls.filter(
      (ctrl: AbstractControl) => !ctrl.value
    );

    this.reloadSubject$.next(controlsToReload);
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription: Subscription) => subscription.unsubscribe());
    this.reloadSubject$.complete();
  }
}
